import { ExtendedAreaModels } from '@bpd-library/utilities';

import shouldDrawPolygon from '../api-utilities/should-draw-polygon';
import {
    createApartmentBuildingMapData,
    createConstructionNumberMapData,
    createProjectPhaseMapData,
    createPropertyTypeMapData,
} from './service';

const extendApiModelsWithMapData = async (
    data: ExtendedAreaModels,
    options?: { alwaysShowSoldProjectPolygons?: boolean },
): Promise<ExtendedAreaModels> => {
    data.constructionNumbers
        .filter((constructionNUmber) => shouldDrawPolygon(constructionNUmber))
        .forEach((constructionNumber) => {
            constructionNumber.mapDataItems = createConstructionNumberMapData(constructionNumber);
        });

    data.propertyTypes
        .filter((propertyType) => shouldDrawPolygon(propertyType))
        .forEach((propertyType) => {
            propertyType.mapDataItems = createPropertyTypeMapData(propertyType);
        });

    for (const projectPhase of data.projectPhases.filter((project) =>
        shouldDrawPolygon(project, options),
    )) {
        projectPhase.mapDataItems = await createProjectPhaseMapData(projectPhase, options);
    }

    data.apartmentBuildings!.forEach((apartmentBuilding) => {
        apartmentBuilding.mapDataItems = createApartmentBuildingMapData(apartmentBuilding);
    });

    return data;
};

export { extendApiModelsWithMapData };
